import { createAsyncThunk } from "@reduxjs/toolkit";
import { handleApiError } from "../../../Common/errorApiHandleUtils";
import { checkFilter } from "../../../Common/filterUtils";
import { adminService } from "../../../Axios/adminService";

export const getAllAdmin = createAsyncThunk(
    'admin/getAllAdmin',
    async (filters, { rejectWithValue }) => {
        try {
            let filter = checkFilter(filters);
            const response = await adminService.getAllAdmin(filter);
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);
// name: rafli
// email: adminbaru @admin.com
// password: admin12345
// is_super_admin: 1
// is_admin: 0
// is_cs: 0
// branch_id: 

export const submitAdmin = createAsyncThunk(
    'admin/submitAdmin',
    async (data, { rejectWithValue }) => {
        try {
            const formData = new FormData();
            data.name && formData.append('name', data.name);
            data.email && formData.append('email', data.email);
            data.password && formData.append('password', data.password);
            formData.append('is_super_admin', data.is_super_admin);
            formData.append('is_admin', data.is_admin);
            formData.append('is_cs', data.is_cs);
            data.branch_id && formData.append('branch_id', data.branch_id);

            let response;
            if (data.id) {
                response = await adminService.updateAdmin(data.id, formData);
            } else {
                response = await adminService.createAdmin(formData);
            }
            data.successCallback && data.successCallback();
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);
export const deleteAdmin = createAsyncThunk(
    'admin/deleteAdmin',
    async (id, { rejectWithValue }) => {
        try {
            const response = await adminService.deleteAdmin(id);
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);
